import { createTheme, FormControlLabel, FormGroup, Switch, ThemeProvider } from "@mui/material";
import { Typography } from "@material-ui/core";

interface Props {
  checked: boolean | undefined;
  onChange: () => void;
  color: string;
  size: "small" | "medium";
  label?: string;
}

const theme = createTheme({
  palette: {
    primary: {
      main: "#ffff",
    },
    secondary: {
      main: "#1976D2",
    },
  },
});

export const SwitchCustom = (props: Props) => {
  return (
    <>
      <ThemeProvider theme={theme}>
        <FormGroup>
          <FormControlLabel
            control={<Switch checked={!!props.checked} onChange={props.onChange} color={"secondary"} size={props.size}/>}
            label={<Typography style={{ fontSize: '0.8rem' }}> {props.label ?? ''} </Typography>}
          />
        </FormGroup>
      </ThemeProvider>
    </>
  );
};
